import React, { useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import {
  Route,
  Switch,
  Redirect,
  useLocation,
  useHistory,
} from "react-router-dom";
import Cookies from "universal-cookie";
import { Spinner } from 'reactstrap';
// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import routes from "routes.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var ps;

function Admin(props) {
  const location = useLocation();
  const [backgroundColor, setBackgroundColor] = React.useState("blue");
  const mainPanel = React.useRef();
  const history = useHistory();
  const cookies = new Cookies();

  React.useEffect(() => {
    var token = cookies.get("token");
    if (token && token != "") {
      if (navigator.platform.indexOf("Win") > -1) {
        ps = new PerfectScrollbar(mainPanel.current);
        document.body.classList.toggle("perfect-scrollbar-on");
      }
      return function cleanup() {
        if (navigator.platform.indexOf("Win") > -1) {
          ps.destroy();
          document.body.classList.toggle("perfect-scrollbar-on");
        }
      };
    } else {
      history.push("/login");
    }
  });
  React.useEffect(() => {
    var token = cookies.get("token");
    if (token && token != "") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      mainPanel.current.scrollTop = 0;
    } else {
      history.push("/login");
    }
  }, [location]);

  const handleColorClick = (color) => {
    setBackgroundColor(color);
  };
  const [IsLoading, setIsLoading] = useState(true)
  
  return (
    <>
      <ToastContainer />
    
      <div className="wrapper">
    
        <Sidebar {...props} routes={routes} backgroundColor={backgroundColor} />
        
        <div className="main-panel" ref={mainPanel}>
          <DemoNavbar {...props} />
          <Switch>
            {routes.map((prop, key) => {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            })}
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <Footer fluid />
        </div>
        <FixedPlugin
          bgColor={backgroundColor}
          handleColorClick={handleColorClick}
        />
      </div>
    </>
  );
}

export default Admin;
